<template>
<app-modal v-model="isDialogOpened"
           size="xs"
           :ok-text="$t('common.app-file-upload.CancelAllFilesDialog.confirmText')"
           :cancel-text="$t('common.app-file-upload.CancelAllFilesDialog.cancelText')"
           @ok="onOk"
           @cancel="closeDialog"
>
  <template #title>{{ $t('common.app-file-upload.CancelAllFilesDialog.title') }}</template>
  <template #body>{{ $t('common.app-file-upload.CancelAllFilesDialog.text') }}</template>
</app-modal>
</template>

<script>
import { mapActions } from 'vuex'

import { dialogMixin } from '@/mixins/dialogMixin'
import { AppUploadHandlerActionTypes } from '@/store/modules/app-upload-handler/action_types'

export default {
  name: 'CancelAllFilesDialog',
  mixins: [dialogMixin],
  methods: {
    ...mapActions('appUploadHandler', [AppUploadHandlerActionTypes.CANCEL_ALL]),
    onOk () {
      this.CANCEL_ALL()
      this.closeDialog()
    },
  },
}
</script>
